import { render, staticRenderFns } from "./AssayStatusBadge.vue?vue&type=template&id=8b4fcc46&scoped=true&"
import script from "./AssayStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AssayStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AssayStatusBadge.vue?vue&type=style&index=0&id=8b4fcc46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4fcc46",
  null
  
)

export default component.exports